export default "﻿<div>\n    <div data-dojo-attach-point=\"syncFusionContainer\"></div>\n</div>\n"